import React from 'react'

const Footer = () => {
  return (
    <>
     <footer className="footer">
            <div className="footer__bg">
                <div className="footer__container container grid">
                    <div>
                        <h1 className="footer__title">Renuka</h1>
                        <span className="footer__subtitle">Software developer</span>
                    </div>
                    <ul className="footer__links">
                        <li>
                            <a href="#skills" className="footer__link">Skills</a>
                            </li>
                            <li>
                            <a href="#portfolio" className="footer__link">Portfolio</a>
                            </li>
                            <li>
                            <a href="#contact" className="footer__link">Contact me</a> </li>
                    </ul>
                    

                    <div className="footer__socials">
                        <a href="https://www.facebook.com/"  className="footer__social"> <i className="uil uil-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/"  className="footer__social"> <i className="uil uil-instagram"></i>
                        </a>
                        <a href="https://twitter.com/"  className="footer__social"> <i className="uil uil-twitter-alt"></i>
                        </a>
                    </div>

                  
                </div>
                <p className="footer__copy">&#169; Renuka Rathva.  All rights reserved</p>
            </div>
        </footer>
    </>
  )
}

export default Footer